import { Component, OnInit, ViewChild, AfterViewInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatAutocompleteTrigger, MatDialog } from '@angular/material';
import { startWith } from 'rxjs/operators/startWith';
import { map } from 'rxjs/operators/map';
import { Question } from '../models/question.class';
import { ErrorCatchDialogComponent } from '../dialogs/error-catch-dialog/error-catch-dialog.component';
import { DataEnadisService } from '../services/data-enadis/data-enadis.service';
import * as d3 from 'd3';
import * as _ from 'lodash';
import * as domtoimage from 'dom-to-image';
import { Option } from '../models/Option.class';
import { Profile } from '../models/Profile.class';
import { Keys } from '../models/Keys.class';

/** Variables that have topic "Sociodemographic" */
const SOCIODEMO_VARS = ['alfa', 'P3_15', 'P3_15', 'P3_17', 'P3_19_1', 'educa2',
  'PEA2', 'P3_19', 'OCUPA', 'P3_7', 'ESTRATO', 'RANGO_EDAD', 'AGE_15', 'AGE_6_24'];
/** General age groups from "COE" group */
const AGE_BIG_GROUPS = ['Todos', '18 a 29 años', '30 a 59 años', '60 o más años'];

/**
 * PerfilesCompoent
 * Allows user to comapre different demographic properties and the responses for a
 * selection of questions from ENADIS 2017
 */
@Component({
  selector: 'app-perfiles',
  templateUrl: './perfiles.component.html',
  styleUrls: ['./perfiles.component.scss']
})
export class PerfilesComponent implements OnInit, AfterViewInit {
  /** Var who marks the number of aplication flow */
  step: number;
  /** On responsive view make population2  to go to right */
  toggleRight = false;
  /** On responsive view make population1 to go to left */
  toggleLeft = false;
  /** Topic Dropdown Controller */
  searchTopic: FormControl;
  /** Variable Dropdown Controller */
  searchIndicator: FormControl;
  /** State for population1 Dropdown Controller */
  searchState2: FormControl;
  /** State for population2 Dropdown Controller */
  searchState3: FormControl;
  /** Education for population1 Dropdown Controller */
  searchEducados1: FormControl;
  /** Education for population2 Dropdown Controller */
  searchEducados2: FormControl;
  /** Contains the value of variable selected by dropdown */
  filteredVariables: any = [];
  /** Contains the value of State for population1 selected by dropdown */
  filteredStates2: any = [];
  /** Contains the value of State for population2 selected by dropdown */
  filteredStates3: any = [];
  /** Contains the value of Education for population1 selected by dropdown */
  filteredEducados1: any = [];
  /** Contains the value of Education for population2 selected by dropdown */
  filteredEducados2: any = [];
  /** Topics filtered names used in this module  */
  filteredTopics: any = [];
  /** Value of Question selected  */
  selectedQuestion: Question;
  /** Value of Education for population1 selected  */
  selectedEducados1: string;
  /** Value of Education for population2 selected  */
  selectedEducados2: string;
  /** Value of State for population1 selected  */
  selectedEstados2: string;
  /** Value of State for population2 selected  */
  selectedEstados3: string;
  /** Variables */
  variables: Question[] = [];
  /** ranges of ages used in questions */
  ageRanges: string;
  /** Just title of Variable in String */
  firstTitle: any;
  /** Just name of question in string for each question */
  secondTitle: any;
  /** Name in string for answer of each question  */
  categor: any;
  /** Name in string for answer option of each question */
  columni: any;
  /** Shortname of question */
  pregunta: any;
  /** Variables that does no show the question name or variable name on graphic  */
  specialQuestions: any = [];
  /** True of question.kind === columna */
  tipo_pregunta: any;
  /** Categorie for first population  */
  firstCategorie: any;
  /** Categorie for second population  */
  firstColumn: any;
  /** Filter Options Object for populations, came from interface "option"  */
  filterOptions: {
    columns: Option,
    categories: Option,
    SEXO: Option,
    educa2: Option,
    P3_9: Option,
    discapacidad: Option,
    ENT: Option,
    identidad: Option,
    RANGO_EDAD: Option,
    AGE_15: Option,
    AGE_6_24: Option,
    P3_8: Option,
    P3_12: Option,
    COLOR_PIEL: Option,
    TLOC: Option,
  };
  /** Contains default values to fill graphics and filters when a variable is selected came from interface "profile" */
  generalProfile: Profile;
  /** Values to change filter and graphics for first population  */
  firstProfile: Profile;
  /** Values to change filter and graphics for second population  */
  secondProfile: Profile;
  /** Value to check not to set the filters of populations down the graphic */
  setProfile: boolean;
  /** Expansion value  */
  expFactor: string;
  /** Data first population */
  firstData: any;
  /** Data second population */
  secondData: any;
  /** Keys */
  keys: Keys;
  /** xAxis Object Structure */
  xAxis: { name: string, slug: string, type: string };
  /** yAxis Object Structure */
  yAxis: { name: string, slug: string, type: string };
  /** Aux to know filters selected */
  filters: any;
  /** Data to set on graphic  */
  dataToDraw: any[];
  /** Aux data while loading  */
  loadingData = false;
  /** Counter for loader spinner */
  counter = 0;
  /** Progress for loader spinner */
  progress: any;
  /** Legend options value for graphs */
  legendOptions: any[];
  /** Colorpalette for graphs  */
  colorPalette: string[];
  /** Options of groupBy */
  groupByOptions: string[];
  /** Question if has a comment on DB */
  questionSpecial: any;
  /** Everytopic for each question  */
  allTopics: Question[];
  /** Just the topics variables have  */
  topicVariables: any;
  /** Filtered topics  */
  topicsNames: {}[];
  /** SelectedTopic value */
  selectedTopic: any;
  /** Selected topics in string */
  selectedTopicName: any;
  /** selected topic slug  */
  selectedTopicSlug: any;
  /** Params to make requests  */
  queryParams: { topicPerfiles: any; };
  /** Filters used for first population  */
  filtersFirstProfile: any[];
  /** Filters used for second population  */
  filtersSecondProfile: any[];
  /** Topics just used in Compara Poblaciones Module not in ENADIS  */
  topicsPerfiles: any[];
  /** Value of comment if question has  */
  comment: string;
  /** Filters names for every filter selected in Population 1  */
  keySelectedValue: any[];
  /** Filters names for every filter selected in Population 2  */
  keySelectedValueSecond: { key: any; value: any; }[];
  /** Boolean to know when to Set filters selected down the graphic for pop1 */
  filterKeys: boolean;
  /** Value of filters selected in population 1  */
  filtersSelected: any = [];
  /** Value of filters selected in population 2  */
  filtersSelectedSecond: any = [];
  /** Color Scale  */
  colorScale: any;
  /** Trigger dropdown for Education Population 1  */
  @ViewChild('mat0', { read: MatAutocompleteTrigger }) trigger1: MatAutocompleteTrigger;
  /** Trigger dropdown for Education Population 2  */
  @ViewChild('mat1', { read: MatAutocompleteTrigger }) trigger2: MatAutocompleteTrigger;
  /** Trigger dropdown for Education State 1  */
  @ViewChild('mat2', { read: MatAutocompleteTrigger }) trigger3: MatAutocompleteTrigger;
  /** Trigger dropdown for Education State 2  */
  @ViewChild('mat3', { read: MatAutocompleteTrigger }) trigger4: MatAutocompleteTrigger;
  /** Trigger dropdown for Topic  */
  @ViewChild('matTopic', { read: MatAutocompleteTrigger }) trigger5: MatAutocompleteTrigger;
  /** Trigger dropdown for Question  */
  @ViewChild('matQuestion', { read: MatAutocompleteTrigger }) trigger6: MatAutocompleteTrigger;
  /** Boolean to know when to Set filters selected down the graphic for pop2 */
  filterKeysSecond: boolean;

  /**
   * Constructor of class PerfilesComponent
   * @param dbService Data Service for ENADIS requests
   * @param dialog Angular Material MatDialog
   */
  constructor(
    private dbService: DataEnadisService,
    private dialog: MatDialog,
  ) { }

  /** Main method of Angular's lifecycle */
  ngOnInit() {
    this.step = 0;
    this.colorPalette = ['#de364b', '#006BB5'];
    this.colorScale = d3.scaleOrdinal(this.colorPalette);
    this.setProfile = false;
    this.ageRanges = 'RANGO_EDAD';
    this.filterOptions = this.dbService.getPerfilesFilterOptions();
    this.generalProfile = {
      columns: undefined,
      categories: undefined,
      SEXO: undefined,
      educa2: undefined,
      P3_9: undefined,
      discapacidad: undefined,
      ENT: undefined,
      identidad: undefined,
      RANGO_EDAD: undefined,
      AGE_15: undefined,
      AGE_6_24: undefined,
      P3_8: undefined,
      P3_12: undefined,
      COLOR_PIEL: undefined,
      TLOC: undefined,
    };
    this.firstProfile = {
      columns: undefined,
      categories: undefined,
      SEXO: undefined,
      educa2: undefined,
      P3_9: undefined,
      discapacidad: undefined,
      ENT: undefined,
      identidad: undefined,
      RANGO_EDAD: undefined,
      AGE_15: undefined,
      AGE_6_24: undefined,
      P3_8: undefined,
      P3_12: undefined,
      COLOR_PIEL: undefined,
      TLOC: undefined,
    };
    this.secondProfile = {
      columns: undefined,
      categories: undefined,
      SEXO: undefined,
      educa2: undefined,
      P3_9: undefined,
      discapacidad: undefined,
      ENT: undefined,
      identidad: undefined,
      RANGO_EDAD: undefined,
      AGE_15: undefined,
      AGE_6_24: undefined,
      P3_8: undefined,
      P3_12: undefined,
      COLOR_PIEL: undefined,
      TLOC: undefined,
    };

    this.searchIndicator = new FormControl();
    this.searchState2 = new FormControl();
    this.searchState3 = new FormControl();
    this.searchEducados1 = new FormControl();
    this.searchEducados2 = new FormControl();
    this.searchTopic = new FormControl();

    this.dbService.getCodebookForProfiles().subscribe(res => {
      this.variables = res;
      this.topicVariables = this.variables;
      this.allTopics = _.uniq(this.variables.filter(function (q) {
        return q.topicPerfiles;
      }));

      const justTopic = _.flatten(this.allTopics.map(function (a) {
        return a.topicPerfiles;
      }));
      this.topicsNames = _.uniq(justTopic).filter(g => g);

      this.topicsNames = this.topicsNames.map((e) => {
        return { name: e, slug: e };
      });
      this.searchIndicator.setValue(' ');

    }, err => {
      alert(err.data.message || err.statusText || err);
    });
    this.filteredTopics = this.searchTopic.valueChanges
      .pipe(
        startWith(''),
        map(topic => {
          if (Array.isArray(this.topicsNames)) {
            return topic ? this.filterTopics(topic) : this.topicsNames.slice();
          } else {
            return [];
          }
        })
      );
    this.filteredVariables = this.searchIndicator.valueChanges
      .pipe(
        startWith(''),
        map(variable => {
          if (Array.isArray(this.topicVariables)) {
            return variable ? this.filterVariables(variable) : this.topicVariables.slice();
          } else {
            return [];
          }
        })
      );
    this.filteredStates2 = this.searchState2.valueChanges
      .pipe(
        startWith(''),
        map(variable => {
          if (Array.isArray(this.variables)) {
            return variable ? this.filterStates1(variable) : this.filterOptions.ENT.options.slice();
          } else {
            return [];
          }
        })
      );
    this.filteredStates3 = this.searchState3.valueChanges
      .pipe(
        startWith(''),
        map(variable => {
          if (Array.isArray(this.variables)) {
            return variable ? this.filterStates2(variable) : this.filterOptions.ENT.options.slice();
          } else {
            return [];
          }
        })
      );
    this.filteredEducados1 = this.searchEducados1.valueChanges
      .pipe(
        startWith(''),
        map(variable => {
          if (Array.isArray(this.variables)) {
            return variable ? this.filterEducados1(variable) : this.filterOptions.educa2.options.slice();
          } else {
            return [];
          }
        })
      );
    this.filteredEducados2 = this.searchEducados2.valueChanges
      .pipe(
        startWith(''),
        map(variable => {
          if (Array.isArray(this.variables)) {
            return variable ? this.filterEducados2(variable) : this.filterOptions.educa2.options.slice();
          } else {
            return [];
          }
        })
      );
    this.setOptions();
  }

  /** Angular's lifecycle method after the first render of page */
  ngAfterViewInit() {
    this.trigger1.panelClosingActions.subscribe(() => {
      this.searchEducados1.setValue(this.selectedEducados1);
    });
    this.trigger2.panelClosingActions.subscribe(() => {
      this.searchEducados2.setValue(this.selectedEducados2);
    });
    this.trigger3.panelClosingActions.subscribe(() => {
      this.searchState2.setValue(this.selectedEstados2);
    });
    this.trigger4.panelClosingActions.subscribe(() => {
      this.searchState3.setValue(this.selectedEstados3);
    });
    this.trigger5.panelClosingActions.subscribe(() => {
      this.searchTopic.setValue(this.selectedTopic);
    });
    this.trigger6.panelClosingActions.subscribe(() => {
      this.searchIndicator.setValue(this.selectedQuestion);
    });
  }

  /**
   * Checks who question is in used to match it's value to graphic and filters, also validates, if has reponses as 'No
   * aplica', 'No sabe', etc.
   * Validates what kind of question is and assigns filter options values
   * @param variableSelected boolean to know if the answer of a variable has changed
   */
  selectQuestion(variableSelected) {
    this.step = 1;
    this.selectedQuestion = this.searchIndicator.value;
    if (!this.selectedTopic && this.selectedQuestion) {
      this.selectedTopic = { name: this.selectedQuestion.topicPerfiles, slug: this.selectedQuestion.topicPerfiles };
      this.searchTopic.setValue(this.selectedTopic);
    }
    if (this.selectedQuestion.kind === 'columna') {
      this.dbService.getColumnsFromQuestionId(this.selectedQuestion.questionId).subscribe((columns: { field: any, name: any }[]) => {
        this.filterOptions.columns = {
          field: 'columns',
          name: this.selectedQuestion.categoryName,
          options: columns
            .sort((a, b) => {
              const opts = ['Sí', 'No', 'Otro', 'Otra', 'No sabe', 'No aplica',
                'No responde', 'No contestó', 'Sí (buscó empleo y se lo negaron)',
                'No (buscó empleo y no se lo negaron)', 'Sabe leer y escribir',
                'No sabe leer ni escribir'];
              if (_.includes(opts, a.name) && _.includes(opts, b.name)) {
                return opts.indexOf(a.name) - opts.indexOf(b.name);
              } else {
                return a.name < b.name ? -1 : 1;
              }
            })
        };
        if ((this.filterOptions.columns.options[0].name === 'Otro') ||
          (this.filterOptions.columns.options[0].name === 'Otra') ||
          (this.filterOptions.columns.options[0].name === 'No sabe') ||
          (this.filterOptions.columns.options[0].name === 'No responde') ||
          (this.filterOptions.columns.options[0].name === 'No aplica') && variableSelected) {
          this.generalProfile.columns = this.filterOptions.columns.options[1];
        } else if (variableSelected) {
          this.generalProfile.columns = this.filterOptions.columns.options[0];
        } else {
          const optionSelected = this.generalProfile.columns.field;
          this.generalProfile.columns = _.find(this.filterOptions.columns.options, function (o) { return o.field === optionSelected; });
          this.firstProfile.columns = this.generalProfile.columns;
          this.secondProfile.columns = this.generalProfile.columns;
        }
      });
    } else { // kind === 'fila'
      this.filterOptions.columns = undefined;
      this.generalProfile.columns = undefined;
    }

    this.dbService.getRowsFromQuestionId(this.selectedQuestion.questionId).subscribe((categories: { field: any, name: any }[]) => {
      categories = categories.filter(opt => {
        return !_.includes(['No especificado', 'No sabe', 'No responde', 'No aplica',
          'No aplica (no buscó empleo)', 'Otro', 'Otra'], opt.name);
      });
      this.filterOptions.categories = {
        field: 'categories',
        name: this.selectedQuestion.kind === 'columna' ? this.selectedQuestion.subcategoryName : this.selectedQuestion.categoryName,
        options: categories
          .sort((a, b) => {
            const opts = ['Sí', 'No', 'Otro', 'Otra', 'No sabe', 'No aplica',
              'No responde', 'No contestó', 'Sí (buscó empleo y se lo negaron)',
              'No (buscó empleo y no se lo negaron)', 'Sabe leer y escribir',
              'No sabe leer ni escribir'];
            if (_.includes(opts, a.name) && _.includes(opts, b.name)) {
              return opts.indexOf(a.name) - opts.indexOf(b.name);
            } else {
              return a.name < b.name ? -1 : 1;
            }
          })
      };

      if ((this.filterOptions.categories.options[0].name === 'Otro') ||
        (this.filterOptions.categories.options[0].name === 'Otra') ||
        (this.filterOptions.categories.options[0].name === 'No responde') ||
        (this.filterOptions.categories.options[0].name === 'No aplica') && variableSelected) {
        this.generalProfile.categories = this.filterOptions.categories.options[1];
      } else if (variableSelected) {
        this.generalProfile.categories = this.filterOptions.categories.options[0];
      } else {
        const optionSelected = this.generalProfile.categories.field;
        this.generalProfile.categories = _.find(this.filterOptions.categories.options, function (o) { return o.field === optionSelected; });
        this.firstProfile.categories = this.generalProfile.categories;
        this.secondProfile.categories = this.generalProfile.categories;
      }
      this.setBothProfiles(variableSelected);
    });
    const indexEdad = this.selectedQuestion.fieldOptions.findIndex(x => x.name === 'Grupo de edad');
    const gruposGrandesEdad = this.filterOptions[this.ageRanges].options.filter(x => _.includes(AGE_BIG_GROUPS, x.name));
    this.ageRanges = this.selectedQuestion.fieldOptions[indexEdad].slug;
    if (this.selectedTopic && this.selectedTopic.name === 'Opiniones y actitudes' ||
      this.selectedTopic.name === 'Prácticas y experiencias de discriminación') {
      this.filterOptions[this.ageRanges].options = gruposGrandesEdad;
    }
    this.generalProfile[this.ageRanges] = this.filterOptions[this.ageRanges].options[0];
  }

  /**
   * Check if the question has a comment if true assign value of comment to variable comment
   */
  getQuestionSpecial() {
    if (this.selectedQuestion.comment && this.selectedQuestion.questionId !== 'OCUPA') {
      this.comment = this.selectedQuestion.comment;
    } else {
      this.comment = '';
    }
    this.specialQuestions = ['PO1_1', 'PO1_2', 'PO1_3', 'PO1_4', 'PO2_1', 'PO2_2',
      'PO2_3', 'PO3_1', 'PM4_3', 'PO3_2', 'PO3_3', 'PO4_1', 'PO4_3', 'PO4_4',
      'PO4_2', 'PO4_5', 'PREVALENCIA', 'NEGACION'];
    if (_.includes(this.specialQuestions, this.selectedQuestion.questionId)) { return this.selectedQuestion.question; }
  }

  /**
   * Check the Topics used in Compara Poblaciones Module and return just those ones variables have
   * @param questions Means all questions in use in Compara Poblaciones
   */
  searchTopics(questions) {
    const qtopic = questions.filter(function (q) {
      if (q && q.topicPerfiles && q.topicPerfiles.includes(',')) {
        q.topicPerfiles = q.topicPerfiles.split(',');
      }
      return q.topicPerfiles !== '';
    });
    this.allTopics = qtopic;
    // JustTopic Brings Just Compara Poblaciones Topics
    const justTopic = _.flatten(qtopic.map(function (a) {
      return a.topicPerfiles;
    }));
    this.topicsNames = _.uniq(justTopic).filter(g => g);

    this.topicsNames = this.topicsNames.map((e) => {
      return { name: e, slug: e };
    });
  }

  /**
   * Set the topic to question in use and set the topics to queryparams
   */
  setTopic() {
    const vm = this;
    this.step = 0;
    this.selectedTopic = this.searchTopic.value;
    this.selectedTopicName = this.selectedTopic.name;
    this.selectedTopicSlug = this.selectedTopic.slug;
    this.topicVariables = this.allTopics.filter(function (fa) {
      const result = fa.topicPerfiles === vm.selectedTopicSlug || (Array.isArray(fa.topicPerfiles) &&
        _.includes(fa.topicPerfiles, vm.selectedTopicSlug));
      return result;
    }.bind(this));
    this.searchIndicator.setValue(undefined);
    this.queryParams = {
      topicPerfiles: this.selectedTopicSlug
    };
    this.nextStep();
  }

  ///  Filtros ///
  /**
   * Filter States For population 1, returns the name of a state selected then show in dropdown state2
   * @param name Name of the state to validate for seachState2 Autocomplete
   */
  filterStates1(name: string) {
    if (typeof name === 'string') {
      this.selectedEstados2 = name;
      return this.filterOptions.ENT.options.filter(state =>
        state.name.toLowerCase().indexOf(name.toLowerCase()) > -1);
    } else if (name['name']) {
      const index = _.findIndex(this.filterOptions.ENT.options, function (o) { return o.name === name['name']; });
      this.firstProfile.ENT = this.filterOptions.ENT.options[index];
      return this.filterOptions.ENT.options.filter(state =>
        state.name.toLowerCase().indexOf((name['name'] as string).toLowerCase()) > -1);
    }
  }

  /**
   * Filter States For population 2, returns the name of a state selected then show in dropdown state3
   * @param name Name of the state to validate for selectedEstados Autocomplete
   */
  filterStates2(name: string) {
    if (typeof name === 'string') {
      this.selectedEstados3 = name;
      return this.filterOptions.ENT.options.filter(state =>
        state.name.toLowerCase().indexOf(name.toLowerCase()) > -1);
    } else if (name['name']) {
      const index = _.findIndex(this.filterOptions.ENT.options, function (o) { return o.name === name['name']; });
      this.secondProfile.ENT = this.filterOptions.ENT.options[index];
      return this.filterOptions.ENT.options.filter(state =>
        state.name.toLowerCase().indexOf((name['name'] as string).toLowerCase()) > -1);
    }
  }

  /**
   * FilterTopics to show in Dropdown SearchTopics, returns the name of topic selected then show it on Topic Autocomplete
   * @param name Name of Topic
   */
  filterTopics(name: string) {
    if (typeof name === 'string') {
      return this.topicsNames.filter(variable =>
        variable['name'].toLowerCase().indexOf(name.toLowerCase()) > -1);
    } else {
      // Variable is a selected object
      this.searchTopics(this.variables);
    }
  }

  /**
   * Filter the names of variable, return the name of selected variable and  show on Inidicator Autocomplete
   * @param name Name of Variable selected
   */
  filterVariables(name: string) {
    if (typeof name === 'string') {
      return this.variables.filter(variable =>
        variable.shortName.toLowerCase().indexOf(name.toLowerCase()) > -1);
    } else if (name['shortName']) {
      // variable is a selected object
      return this.variables.filter(variable =>
        variable.shortName.toLowerCase().indexOf((name['shortName'] as string).toLowerCase()) > -1);
    }
  }

  /**
   * Filter Education For population 1, returns the name of state to show in dropdown searchEduca1
   * @param name Name of education Range selected
   */
  filterEducados1(name: string) {
    if (typeof name === 'string') {
      this.selectedEducados1 = name;
      return this.variables.filter(variable =>
        variable.shortName.toLowerCase().indexOf(name.toLowerCase()) > -1);
    } else if (name['name']) {
      if (this.filterOptions.educa2.options[this.filterOptions.educa2.options.length - 1].name === 'No especificado') {
        this.filterOptions.educa2.options.pop();
      }
      const index = _.findIndex(this.filterOptions.educa2.options, function (o) { return o.name === name['name']; });
      this.firstProfile.educa2 = this.filterOptions.educa2.options[index];
      // this.getData(); // variable is a selected object
      return this.variables.filter(variable =>
        variable.shortName.toLowerCase().indexOf((name['name'] as string).toLowerCase()) > -1);
    }
  }

  /**
   * Filter Education For population 2, returns the name of state to show in dropdown searchEduca2
   * @param name Name of education Range selected
   */
  filterEducados2(name: string) {
    if (typeof name === 'string') {
      this.selectedEducados2 = name;
      return this.variables.filter(variable =>
        variable.shortName.toLowerCase().indexOf(name.toLowerCase()) > -1);
    } else if (name['name']) {
      const index = _.findIndex(this.filterOptions.educa2.options, function (o) { return o.name === name['name']; }
      );
      this.secondProfile.educa2 = this.filterOptions.educa2.options[index];
      // this.getData(); // variable is a selected object
      return this.variables.filter(variable =>
        variable.shortName.toLowerCase().indexOf((name['name'] as string).toLowerCase()) > -1);
    }
  }

  /**
   * Uses d3 to select which elements of the DOM are going to be selected and match to an .jpeg image
   */
  downloadImage(): void {
    d3.select('.row.center-align.margin-buttons').style('display', 'none');
    d3.select('.general-note').style('display', 'none');
    const element = d3.select('.col.s5.center-align.responsive-chart').node();
    domtoimage.toJpeg(element, { quality: 0.95, bgcolor: 'white' })
      .then(function (dataUrl: string) {
        const link = document.createElement('a');
        link.download = 'compara-poblaciones.jpeg';
        link.href = dataUrl;
        link.click();
      });
    setTimeout(() => {
      d3.select('.row.center-align.margin-buttons').style('display', 'block');
      d3.select('.general-note').style('display', 'block');
    }, 1);
  }

  /// Display's ///
  /**
   * Display variables on Autocomplete Variable if there's no topic selected returns every variable
   * If there's a topic selected, it is just to display the variables that match that topic
   * @param variable Question that's going to be used for chart
   */
  displayFn(variable?: Question): string | undefined {
    return variable ? variable.shortName : undefined;
  }

  /**
   * Display the names of the states on Both States Autocompletes
   * @param variable Names of the states
   */
  displayState(variable?: any): string | undefined {
    return variable ? variable.name : undefined;
  }

  /**
   * Display education ranges on Both Education Autocompletes
   * @param variable Names of education Ranges
   */
  displayEduca(variable?: any): string | undefined {
    return variable ? variable.name : undefined;
  }

  /**
   * Display variables on searchTopic Autocomplete
   * @param variable Name of all topics
   */
  displayTopics(variable?: any): string | undefined {
    return variable ? variable.name : undefined;
  }

  /** Sets null as the value of searchIndicator Autocomplete */
  eraseSearch() {
    this.searchIndicator.setValue('');
  }

  /** Sets null as the value of searchTopic Autocomplete */
  eraseTopic() {
    this.searchTopic.setValue('');
  }

  /** Sets null as the value of searchstate2 Autocomplete */
  eraseState2() {
    this.searchState2.setValue('');
  }

  /** Sets null as the value of searchstate3 Autocomplete */
  eraseState3() {
    this.searchState3.setValue('');
  }

  /** Sets null as the value of searchsEducados1 Autocomplete */
  eraseSearchEducados1() {
    this.searchEducados1.setValue(undefined);
  }

  /** Sets null as the value of searchsEducados2 Autocomplete */
  eraseSearchEducados2() {
    this.searchEducados2.setValue(undefined);
  }

  /**
   * Makes possible Responsive view to toggle populations to the left or to the right
   * @param side string with name of the side right or left is going to be showed
   */
  ocultarGrupos(side) {
    if (side === 'right') {
      this.toggleRight = !this.toggleRight;
      if (window.outerWidth <= 600 && this.toggleRight) {
        this.toggleLeft = false;
      }
    }
    if (side === 'left') {
      this.toggleLeft = !this.toggleLeft;
      if (window.outerWidth <= 600 && this.toggleLeft) {
        this.toggleRight = false;
      }
    }
  }

  /** Set default options to The Profile it´s gonna show before filters are entered */
  setOptions() {
    const vm = this;
    this.setProfile = false;
    // Sex
    this.generalProfile.SEXO = this.filterOptions.SEXO.options[0];

    // Lengua indígena
    this.generalProfile.P3_9 = this.filterOptions.P3_9.options[0];

    // Discapacidad
    this.generalProfile.discapacidad = this.filterOptions.discapacidad.options[0];

    // Entidad
    this.generalProfile.ENT = this.filterOptions.ENT.options[0];
    this.searchState2.setValue(this.generalProfile.ENT);
    this.searchState3.setValue(this.generalProfile.ENT);

    // Educación
    if (this.filterOptions.educa2.options[this.filterOptions.educa2.options.length - 1].name === 'No especificado') {
      this.generalProfile.educa2 = this.filterOptions.educa2.options[this.filterOptions.educa2.options.length - 2];
    } else {
      this.generalProfile.educa2 = this.filterOptions.educa2.options[this.filterOptions.educa2.options.length - 1];
    }
    this.searchEducados1.setValue(this.generalProfile.educa2);
    this.searchEducados2.setValue(this.generalProfile.educa2);

    // Identidad
    this.generalProfile.identidad = this.filterOptions.identidad.options[0];

    // Tono de piel
    this.generalProfile.COLOR_PIEL = this.filterOptions.COLOR_PIEL.options[0];

    // Edad
    this.generalProfile[this.ageRanges] = this.filterOptions[this.ageRanges].options[0];

    // Tamaño de localidad
    this.generalProfile.TLOC = this.filterOptions.TLOC.options[0];

  }

  /**
   * Makes the First Population values go to defaults
   */
  resetFirstProfile() {
    this.firstProfile = _.clone(this.generalProfile);
    this.firstProfile.ENT = this.filterOptions.ENT.options[0];
    this.searchState2.setValue(this.firstProfile.ENT);
    if (this.filterOptions.educa2.options[this.filterOptions.educa2.options.length - 1].name === 'No especificado') {
      this.firstProfile.educa2 = this.filterOptions.educa2.options[this.filterOptions.educa2.options.length - 2];
    } else {
      this.firstProfile.educa2 = this.filterOptions.educa2.options[this.filterOptions.educa2.options.length - 1];
    }
    this.searchEducados1.setValue(this.firstProfile.educa2);
    if (this.filtersSelected && this.keySelectedValue) {
      this.filtersSelected.splice(0);
      this.keySelectedValue.splice(0);
      this.filterKeysSecond = false;
    }
  }

  /**
   * Makes the Second Population values go to defaults
   */
  resetSecondProfile() {
    this.secondProfile = _.clone(this.generalProfile);
    this.secondProfile.ENT = this.filterOptions.ENT.options[0];
    this.searchState3.setValue(this.secondProfile.ENT);
    if (this.filterOptions.educa2.options[this.filterOptions.educa2.options.length - 1].name === 'No especificado') {
      this.secondProfile.educa2 = this.filterOptions.educa2.options[this.filterOptions.educa2.options.length - 2];
    } else {
      this.secondProfile.educa2 = this.filterOptions.educa2.options[this.filterOptions.educa2.options.length - 1];
    }
    this.searchEducados2.setValue(this.secondProfile.educa2);
    if (this.filtersSelectedSecond && this.keySelectedValueSecond) {
      this.filtersSelectedSecond.splice(0);
      this.keySelectedValueSecond.splice(0);
      this.filterKeys = false;
    }
  }

  /**
   * Makes the Both Populations values go to defaults
   */
  resetBothProfiles() {
    this.resetFirstProfile();
    this.resetSecondProfile();
    this.filterKeys = false;
    this.filterKeysSecond = false;
    if (this.filtersSelected.length > 0) {
      this.filtersSelected.splice(0);
    }
    if (this.filtersSelectedSecond.length > 0) {
      this.filtersSelectedSecond.splice(0);
    }
    setTimeout(() => {
      this.getData();
    }, 500);
  }

  /**
   * Returns if at least first profile is set to display chart
   */
  profileIsSet(): boolean {
    return this.setProfile;
  }

  /**
   * Set the step of app's flow
   * @param index Number of step to set
   */
  setStep(index: number) {
    this.step = index;
  }

  /**
   * Increases the step to make app's flow continue
   */
  nextStep() {
    this.step++;
  }

  /**
   * Decreases step to get back to an app's flow point
   */
  prevStep() {
    this.step--;
  }

  /**
   * Sets the value to every autocomplete and validates if filterKeys for both populations are setted and splice
   * @param variableSelected contains a variable wich is going to set default values according to it
   */
  setBothProfiles(variableSelected) {
    if (variableSelected) {
      this.firstProfile = _.clone(this.generalProfile);
      this.secondProfile = _.clone(this.generalProfile);
      this.searchEducados1.setValue(this.generalProfile.educa2);
      this.searchEducados2.setValue(this.generalProfile.educa2);
      this.searchState2.setValue(this.generalProfile.ENT);
      this.searchState3.setValue(this.generalProfile.ENT);
      this.setProfile = true;
      this.filterKeys = false;
      this.filterKeysSecond = false;
      if (this.filtersSelected.length > 0) {
        this.filtersSelected.splice(0);
      }
      if (this.filtersSelectedSecond.length > 0) {
        this.filtersSelectedSecond.splice(0);
        this.keySelectedValueSecond.splice(0);
      }
    }
    this.getData();
  }

  /**
   * Check if filters are less than 4 and assign filters to an array for population 1 and population 2
   * Those Arrays are gonna be checked to appear down the graphic or not
   * @param evt name of filters, same as filterOptions structure (SEXO, P3_9), etc
   * @param profile if it is firstProfile or secondProfile
   */
  validateFilters(evt, profile) {
    const vm = this;
    if (profile === 'firstProfile') {
      if (evt) {
        this.filterKeys = true;
        if (_.includes(this.filtersSelected, evt) === false && this.filtersSelected.length < 4) {
          this.filtersSelected.push(evt);
        }
      }
      this.filtersFirstProfile = Object.keys(this.firstProfile).filter(key => {
        return (key !== 'categories' && key !== 'columns') &&
          (vm.firstProfile[key] && vm.firstProfile[key].field);
      });
    } else if (profile === 'secondProfile') {
      if (evt) {
        this.filterKeysSecond = true;
        if (_.includes(this.filtersSelectedSecond, evt) === false && this.filtersSelectedSecond.length < 4) {
          this.filtersSelectedSecond.push(evt);
        }
      }
      this.filtersSecondProfile = Object.keys(this.secondProfile).filter(key => {
        return (key !== 'categories' && key !== 'columns') &&
          (vm.secondProfile[key] && vm.secondProfile[key].field);
      });
    }
    if (this.filtersFirstProfile) {
      this.keySelectedValue = this.filtersSelected.map((elem) => ({ key: vm.filterOptions[elem].name, value: vm.firstProfile[elem].name }));
    }
    if (this.filtersSecondProfile) {
      this.keySelectedValueSecond = this.filtersSelectedSecond
        .map(elem => ({ key: vm.filterOptions[elem].name, value: vm.secondProfile[elem].name }));
    }
    if (this.filtersSelected && this.filtersSelected.length > 3) {
      this.filtersFirstProfile.splice(0);
      const dialogRef = this.dialog.open(ErrorCatchDialogComponent, {
        panelClass: 'light-themed-dialog',
        width: '400px',
        data: {
          error: 'Por motivos de precisión estadística, solo se pueden seleccionar hasta tres filtros'
        }
      });
      dialogRef.afterClosed().subscribe(result => {
        this.resetFirstKey(this.filtersSelected[3]);
        this.keySelectedValue.pop();
        this.filtersSelected.pop();
        this.filterKeys = true;
      });
    } else if (this.filtersSelectedSecond && this.filtersSelectedSecond.length > 3) {
      this.filtersSecondProfile.splice(0);
      const dialogRef = this.dialog.open(ErrorCatchDialogComponent, {
        panelClass: 'light-themed-dialog',
        width: '400px',
        data: {
          error: 'Por motivos de precisión estadística, solo se pueden seleccionar hasta tres filtros'
        }
      });
      dialogRef.afterClosed().subscribe(result => {
        this.resetSecondKey(this.filtersSelectedSecond[3]);
        this.keySelectedValueSecond.pop();
        this.filtersSelectedSecond.pop();
        this.filterKeysSecond = true;
      });
    }
  }

  /**
   * Receive the filters that have been selected on the first population
   * and get the value to their defaults, sets the value of autocompletes to default
   * @param keys Name of the key that was selected as the fourth, and has to be rested
   */
  resetFirstKey(keys) {
    this.filterKeys = true;
    switch (keys) {
      case 'ENT':
        this.firstProfile.ENT = this.filterOptions.ENT.options[0];
        this.searchState2.setValue(this.firstProfile.ENT);
        break;
      case 'educa2':
        this.firstProfile.educa2 = this.filterOptions.educa2.options[this.filterOptions.educa2.options.length - 2];
        this.searchEducados1.setValue(this.firstProfile.educa2);
        break;
      case 'ageRanges':
        this.firstProfile[this.ageRanges] = this.generalProfile[this.ageRanges];
        break;
      default:
        this.firstProfile[keys] = this.generalProfile[keys];
        break;
    }
  }

  /**
   * Receive the filters that have been selected on the second population
   * and get the value to their defaults, sets the value of autocompletes to default
   * @param keys Name of the key that was selected as the fourth, and has to be rested
   */
  resetSecondKey(keys) {
    this.filterKeysSecond = true;
    switch (keys) {
      case 'ENT':
        this.secondProfile.ENT = this.filterOptions.ENT.options[0];
        this.searchState3.setValue(this.secondProfile.ENT);
        break;
      case 'educa2':
        this.secondProfile.educa2 = this.filterOptions.educa2.options[this.filterOptions.educa2.options.length - 2];
        this.searchEducados2.setValue(this.secondProfile.educa2);
        break;
      case 'ageRanges':
        this.secondProfile[this.ageRanges] = this.generalProfile[this.ageRanges];
        break;
      default:
        this.secondProfile[keys] = this.generalProfile[keys];
        break;
    }
  }

  /**
   * Checks is there's a question selected, start progress loader spiner, assign options and values
   * Validates results fof variable selected, sets defaults values, and calls important functions like getFirstColumn(),
   * to set the value above graphic.
   */
  getData() {
    const vm = this;
    if (this.selectedQuestion) {
      const config = this.setParamsToRequest(); // Get generated filters and keys
      const filters = config.filters;
      const keys = config.keys;
      this.loadingData = true;
      this.progress = setInterval(function () {
        if (vm.counter < 92) {
          vm.counter += Math.floor(Math.random() * (5 - 0 + 1)) + 0;
        }
      }, 600);
      let collapseBy = keys.collapseBy;
      if (this.selectedQuestion['relativePercentage']) {
        vm.keys.xAxis = 'categories';
        vm.keys.groupBy = 'columns';
        keys['relativePercentage'] = true;
        keys.xAxis = 'categories';
        keys.groupBy = 'columns';
        delete keys.project['columns'];
        filters['categories'] = 'Sí';
        collapseBy = 'totalByGroup';
      }
      this.dbService.getDataToDraw(this.selectedQuestion.questionId, filters, keys).subscribe(result => {
        // firstData
        this.firstData = { x: 'Perfil 1' };
        if (vm.keys.groupBy) {
          this.firstData[this.firstProfile[keys.groupBy].name] = 0;
        } else {
          this.firstData[collapseBy] = 0;
        }
        // keys in firstProfile that are not ALL option
        const wholeKeys = Object.keys(this.firstProfile);
        const firstKeys = wholeKeys.filter(key => {
          return key !== 'identidad' &&
            (vm.keys.groupBy !== key || !vm.keys.groupBy)
            && vm.firstProfile[key] && vm.firstProfile[key].field;
        });
        // Filtered result that matches selected keys
        const firstResult = result.filter(element => {
          let valid = true;
          for (let j = 0; j < firstKeys.length; j++) {
            const k = firstKeys[j];
            valid = valid && (element[k] === vm.firstProfile[k].name || element[k] === vm.firstProfile[k].field);
          }
          return valid;
        });
        if (firstResult.length === 0) {
          console.warn(this.firstProfile);
          const dialogRef = this.dialog.open(ErrorCatchDialogComponent, {
            panelClass: 'light-themed-dialog',
            width: '400px',
            data: {
              error: 'No existen resultados para la combinación del perfil 1. Revisa tu selección de filtros'
            }
          });
        }
        if (firstResult.length === 1) { // One result
          this.firstData = Object.assign(this.firstData, firstResult[0]);
        } else if (firstResult.length > 1) { // Multiple results
          // "Todos" is selected. Many documents in result. Should calculate total value
          // Eg. OCUPA by SEXO -> ((22.7% * 21420691) + (19.7% * 33326916)) / (21420691 + 33326916) = 20.873787796788996%
          let nominator = 0;
          let denominator = 0;
          for (let index = 0; index < firstResult.length; index++) {
            const element = firstResult[index];
            if (element.hasOwnProperty(this.firstProfile[keys.groupBy].name)) {
              nominator += (element[this.firstProfile[keys.groupBy].name] * element[collapseBy]);
            }
            denominator += element[collapseBy];
          }
          const value = denominator !== 0 ? nominator / denominator : 0;
          wholeKeys.forEach(o => {
            if (this.firstProfile[o]) {
              this.firstData[o] = this.firstProfile[o].name || this.firstProfile[o];
            }
          });
          this.firstData[this.firstProfile[keys.groupBy].name] = value; // Set total calculated
        }

        // secondData
        this.secondData = { x: 'Perfil 2' };
        if (vm.keys.groupBy) {
          this.secondData[this.secondProfile[keys.groupBy].name] = 0;
        } else {
          this.secondData[collapseBy] = 0;
        }
        const wholeSecondKeys = Object.keys(this.secondProfile);
        const secondKeys = wholeSecondKeys.filter(key => {
          return key !== 'identidad' &&
            (vm.keys.groupBy !== key || !vm.keys.groupBy) &&
            vm.secondProfile[key] && vm.secondProfile[key].field;
        }); // keys in secondProfile that are not ALL option
        const secondResult = result.filter(element => {
          let valid = true;
          for (let j = 0; j < secondKeys.length; j++) {
            const k = secondKeys[j];
            valid = valid && (element[k] === vm.secondProfile[k].name || element[k] === vm.secondProfile[k].field);
          }
          return valid;
        }); // Filtered result that matches selected keys

        if (secondResult.length === 0) {
          console.warn(this.secondProfile);
          const dialogRef = this.dialog.open(ErrorCatchDialogComponent, {
            panelClass: 'light-themed-dialog',
            width: '400px',
            data: {
              error: 'No existen resultados para la combinación del perfil 2. Revisa tu selección de filtros'
            }
          });
        }
        if (secondResult.length === 1) {
          this.secondData = Object.assign(this.secondData, secondResult[0]);
        } else if (secondResult.length > 1) {
          // "Todos" is selected. Many documents in result. Should calculate total value
          // Eg. OCUPA -> ((22.7 * 21420691) + (19.7 * 33326916)) / (21420691 + 33326916) = 20.873787796788996
          let nominator = 0;
          let denominator = 0;
          for (let index = 0; index < secondResult.length; index++) {
            const element = secondResult[index];
            if (element.hasOwnProperty(this.secondProfile[keys.groupBy].name)) {
              nominator += (element[this.secondProfile[keys.groupBy].name] * element
              [collapseBy]);
            }
            denominator += element[collapseBy];
          }
          const value = denominator !== 0 ? nominator / denominator : 0;
          wholeSecondKeys.forEach(o => {
            if (this.secondProfile[o]) {
              this.secondData[o] = this.secondProfile[o].name;
            }
          });
          this.secondData[this.secondProfile[keys.groupBy].name] = value; // Set calculated total
        }

        this.firstData.y = this.keys.groupBy && this.firstProfile[this.keys.groupBy] &&
          this.firstProfile[this.keys.groupBy].name && this.firstData[this.firstProfile[this.keys.groupBy].name] !== undefined ?
          this.firstData[this.firstProfile[this.keys.groupBy].name] : this.firstData[this.expFactor];
        this.secondData.y = this.keys.groupBy && this.secondProfile[this.keys.groupBy] &&
          this.secondProfile[this.keys.groupBy].name && this.secondData[this.secondProfile[this.keys.groupBy].name] !== undefined ?
          this.secondData[this.secondProfile[this.keys.groupBy].name] : this.secondData[this.expFactor];
        // Join data
        this.dataToDraw = [this.firstData, this.secondData];
        this.counter = 0;
        this.loadingData = false;
        this.tipo_pregunta = this.selectedQuestion.kind === 'columna' ? true : false;
        this.firstCategorie = this.getFirstCategorieTitle();
        this.questionSpecial = this.getQuestionSpecial();
        if (this.tipo_pregunta) {
          this.firstColumn = this.getFirstColumnTitle();
        }
        this.colorScale.domain(_.uniq(this.dataToDraw.map(d => d.x)));
      }, error => {
        console.error(error);
        const dialogRef = this.dialog.open(ErrorCatchDialogComponent, {
          panelClass: 'light-themed-dialog',
          width: '400px',
          data: {
            error: error.error.message.toString() || error.statusText.toString() ||
              error.message.toString() || error
          }
        });
        dialogRef.afterClosed().subscribe(result => {
          clearInterval(this.progress);
          this.counter = 0;
          this.loadingData = false;
        });
      });
    }
  }

  /**
   * Prepare the values to respective variables
   * to make a request, bring data to represent in graphics filtes, etc.
   */
  setParamsToRequest(): { filters: {}, keys: Keys } {
    const vm = this;
    // Parse "identidad"
    this.firstProfile.P3_8 = this.filterOptions.P3_8.options[0];
    this.firstProfile.P3_12 = this.filterOptions.P3_12.options[0];
    if (this.firstProfile && this.firstProfile.identidad && this.firstProfile.identidad.field !== '') {
      if (this.firstProfile.identidad.field === 'BOTH') {
        this.firstProfile.P3_8 = this.filterOptions.P3_8.options[1];
        this.firstProfile.P3_12 = this.filterOptions.P3_12.options[1];
      } else {
        const opt = this.firstProfile.identidad.field;
        this.firstProfile[opt] = this.filterOptions[opt].options[1];
      }
    }
    // Parse "identidad"
    this.secondProfile.P3_8 = this.filterOptions.P3_8.options[0];
    this.secondProfile.P3_12 = this.filterOptions.P3_12.options[0];
    if (this.secondProfile && this.secondProfile.identidad && this.secondProfile.identidad.field !== '') {
      if (this.secondProfile.identidad.field === 'BOTH') {
        this.secondProfile.P3_8 = this.filterOptions.P3_8.options[1];
        this.secondProfile.P3_12 = this.filterOptions.P3_12.options[1];
      } else {
        const opt = this.secondProfile.identidad.field;
        this.secondProfile[opt] = this.filterOptions[opt].options[1];
      }
    }
    const filters = {};
    // Get whole keys for both profiles
    const keys = Object.keys(this.firstProfile).filter(key => {
      return (key !== 'identidad' && key !== 'categories') &&
        (vm.firstProfile[key] && vm.firstProfile[key].field);
    }).concat(Object.keys(this.secondProfile).filter(key => {
      return (key !== 'identidad' && key !== 'categories') &&
        (vm.secondProfile[key] && vm.secondProfile[key].field);
    }));
    filters['categories'] = 'Todos';
    filters['columns'] = 'Todos';
    if (!filters[this.ageRanges]) {
      filters[this.ageRanges] = 'Todos';
    }
    for (let index = 0; index < keys.length; index++) {
      const key = keys[index];
      filters[key] = 'Todos';
    }

    if (this.selectedQuestion) {
      // Validate expansion factor
      this.expFactor = _.includes(SOCIODEMO_VARS, this.selectedQuestion.questionId) ? 'FACTOR_SDE' : 'FACTOR_COE';
      let xAxis = this.selectedQuestion.kind === 'columna' ? 'columns' : 'categories';
      let groupBy = this.selectedQuestion.kind === 'columna' ? 'categories' : '';
      // Generate project
      const project = {};
      if (keys.length > 0) {
        if (!groupBy) { // question kind "fila" xAxis defined as categories, must change
          groupBy = 'categories';
          xAxis = keys.pop();
        }
        for (let i = 0; i < keys.length; i++) {
          const key = keys[i];
          project[key] = 1;
        }
      }
      const options = {
        collapseBy: this.expFactor,
        expFactor: this.expFactor,
        groupBy: groupBy,
        project: project,
        xAxis: xAxis,
        yAxis: this.expFactor,
      };
      filters['unidad'] = 'Porcentaje';
      this.filters = filters;
      if (this.expFactor === 'FACTOR_SDE') {
        filters['dum_sde'] = 1;
      } else {
        filters['dum_coe'] = 1;
      }
      this.keys = options;
      this.legendOptions = this.keys.groupBy ? this.filterOptions[this.keys.groupBy].options.map(o => {
        o.active = true;
        return o;
      }) : [{ name: 'Perfil 1', active: true }, { name: 'Perfil 2', active: true }];
      this.xAxis = { name: 'Perfiles', slug: 'x', type: 'ordinal' };
      this.yAxis = { name: this.filterOptions.categories.name, slug: 'y', type: 'linear' };
      this.groupByOptions = _.uniq([this.firstProfile.categories.name, this.secondProfile.categories.name]);
      return { filters: filters, keys: options };
    } else {
      return {
        filters: {}, keys: {
          collapseBy: 'FACTOR_SDE',
          expFactor: 'FACTOR_SDE',
          groupBy: '',
          project: {},
          xAxis: 'categories',
          yAxis: 'FACTOR_SDE',
        }
      };
    }
  }

  /**
   * Gets name of answer for variable selected, every time it is changed it's gonna be displayed above graphic
   */
  getFirstCategorieTitle() {
    if (this.firstData) {
      this.pregunta = this.selectedQuestion.shortName;
      this.categor = this.filterOptions.categories.name;
      const categorie = this.firstProfile.categories ? this.firstProfile.categories.name : '';
      return categorie;
    }
  }

  /**
   * Gets name of answer's options for variable selected, every time it is changed it's gonna be displayed above graphic
   */
  getFirstColumnTitle() {
    if (this.firstData) {
      this.columni = this.filterOptions.columns.name;
      if (this.selectedQuestion && this.selectedQuestion.kind === 'columna') {
        const columns = this.firstProfile.columns ? this.firstProfile.columns.name : '';
        return columns;
      }
    }
  }

  /**
   * Once Chart is rendered on the page, using D3 selects tick labels of each bar and set an css class
   * to make ticks to each color of bar.
   * @param $event Receive is there has been a change on the chart
   */
  onChartDrawn($event) {
    d3.selectAll('.dbox-label-coefficient').remove();
    d3.selectAll('.x.axis .tick').remove();
    d3.selectAll('.y.axis .tick').remove();
    d3.selectAll('.dbox-label')
      .attr('class', function (d, i) {
        if (i === 0) {
          return 'text-bar1';
        } else {
          return 'text-bar2';
        }
      });
  }

  /**
   * Make a reset of filters, and stop the default html functionality of a button
   * @param $event Receive the event to trigger the reset
   */
  reset($event) {
    // Prevent form submit
    $event.preventDefault();
    $event.stopPropagation();
  }
}



// WEBPACK FOOTER //
// ./src/app/perfiles/perfiles.component.ts